import { render, staticRenderFns } from "./newDaily.vue?vue&type=template&id=7897dc13&scoped=true"
import script from "./newDaily.vue?vue&type=script&lang=js"
export * from "./newDaily.vue?vue&type=script&lang=js"
import style0 from "./newDaily.vue?vue&type=style&index=0&id=7897dc13&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7897dc13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7897dc13')) {
      api.createRecord('7897dc13', component.options)
    } else {
      api.reload('7897dc13', component.options)
    }
    module.hot.accept("./newDaily.vue?vue&type=template&id=7897dc13&scoped=true", function () {
      api.rerender('7897dc13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/help/newDaily.vue"
export default component.exports